export const UnSubmittedContract = () => {
  return (
    <div className="flex flex-col items-center justify-center pt-10 pb-16">
      <h5 className="mb-4 text-24px leading-[1.25]">契約内容は届いていません</h5>
      <p className="whitespace-pre-line text-center text-text-gray">
        {"契約者が契約フォームを記入して返信すると\nこのページで契約内容を確認いただけます"}
      </p>
    </div>
  );
};
